import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BrainIcon, LockIcon } from 'lucide-react';
import { AIConfigOverview } from '../components/ai-config/AIConfigOverview';
import { DataSourcesView } from '../components/ai-config/DataSourcesView';
import { SchemasView } from '../components/ai-config/SchemasView';
import { AttributesView } from '../components/ai-config/AttributesView';
import { PromptsView } from '../components/ai-config/PromptsView';
import { GuardrailsView } from '../components/ai-config/GuardrailsView';
import { EmbeddingsView } from '../components/ai-config/EmbeddingsView';
import { EvaluationView } from '../components/ai-config/EvaluationView';
import { SyncHealthView } from '../components/ai-config/SyncHealthView';
import { AuditView } from '../components/ai-config/AuditView';
export function AIConfigurationPage() {
  const {
    section
  } = useParams<{
    section: string;
  }>();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('overview');
  // Mock: Free plan users see read-only demo
  const userPlan = 'Free'; // Change to 'Growth' to unlock
  useEffect(() => {
    if (section) {
      setActiveSection(section);
    }
  }, [section]);
  const handleSectionChange = (newSection: string) => {
    setActiveSection(newSection);
    navigate(`/ai-config/${newSection}`);
  };
  const tabs = [{
    id: 'overview',
    label: 'Overview'
  }, {
    id: 'data-sources',
    label: 'Data Sources'
  }, {
    id: 'schemas',
    label: 'Schemas'
  }, {
    id: 'attributes',
    label: 'Attributes'
  }, {
    id: 'prompts',
    label: 'Prompts'
  }, {
    id: 'guardrails',
    label: 'Guardrails'
  }, {
    id: 'embeddings',
    label: 'Embeddings'
  }, {
    id: 'evaluation',
    label: 'Evaluation'
  }, {
    id: 'sync',
    label: 'Sync & Health'
  }, {
    id: 'audit',
    label: 'Audit'
  }];
  return <div className="w-full h-screen flex flex-col bg-gray-50" data-id="element-4418">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4" data-id="element-4419">
        <div className="flex items-center justify-between" data-id="element-4420">
          <div data-id="element-4421">
            <div className="flex items-center gap-2" data-id="element-4422">
              <BrainIcon className="w-6 h-6 text-red-600" data-id="element-4423" />
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-4424">
                AI Configuration
              </h1>
            </div>
            <p className="text-sm text-gray-600 mt-1" data-id="element-4425">
              Manage data sources, schemas, prompts, and AI quality controls
            </p>
          </div>
          {userPlan === 'Free' && <div className="flex items-center gap-2 px-4 py-2 bg-purple-50 text-purple-700 rounded-lg border border-purple-200" data-id="element-4426">
              <LockIcon className="w-4 h-4" data-id="element-4427" />
              <span className="text-sm font-medium" data-id="element-4428">
                Read-only demo mode - Upgrade to configure
              </span>
            </div>}
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white border-b border-gray-200 px-6 overflow-x-auto" data-id="element-4429">
        <div className="flex gap-6" data-id="element-4430">
          {tabs.map(tab => <button key={tab.id} onClick={() => handleSectionChange(tab.id)} className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeSection === tab.id ? 'border-red-600 text-red-600' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-4431">
              {tab.label}
            </button>)}
        </div>
      </div>
      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6" data-id="element-4432">
        {activeSection === 'overview' && <AIConfigOverview userPlan={userPlan} data-id="element-4433" />}
        {activeSection === 'data-sources' && <DataSourcesView userPlan={userPlan} data-id="element-4434" />}
        {activeSection === 'schemas' && <SchemasView userPlan={userPlan} data-id="element-4435" />}
        {activeSection === 'attributes' && <AttributesView userPlan={userPlan} data-id="element-4436" />}
        {activeSection === 'prompts' && <PromptsView userPlan={userPlan} data-id="element-4437" />}
        {activeSection === 'guardrails' && <GuardrailsView userPlan={userPlan} data-id="element-4438" />}
        {activeSection === 'embeddings' && <EmbeddingsView userPlan={userPlan} data-id="element-4439" />}
        {activeSection === 'evaluation' && <EvaluationView userPlan={userPlan} data-id="element-4440" />}
        {activeSection === 'sync' && <SyncHealthView userPlan={userPlan} data-id="element-4441" />}
        {activeSection === 'audit' && <AuditView userPlan={userPlan} data-id="element-4442" />}
      </div>
    </div>;
}